import { Layout, Link } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledButton,
  StyledDescription,
  StyledNotFoundWrapper,
  StyledTitle,
} from './NotFound.styles';
import type { NotFoundProps } from './NotFound.types';

export const NotFound = ({ blogPosts }: NotFoundProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <StyledNotFoundWrapper>
        <StyledTitle variant="display_lg">404</StyledTitle>
        <StyledDescription px={2} paragraph variant="regular_600">
          The page you requested could not be found
        </StyledDescription>
        <Link to="/">
          <StyledButton>Back to home page</StyledButton>
        </Link>
      </StyledNotFoundWrapper>
    </Layout>
  );
};
